/* eslint-disable no-unused-expressions */
export default class SharePage {
  constructor({ htmlBody }) {
    this.htmlBody = htmlBody;
    this.shareSection = this.htmlBody.find('.page-share');
    this.init();
  }

  init = () => {
    setTimeout(() => {
      this.shareSection.length && this.shareIt();
    }, 1000);
  };

  shareIt = () => {
    this.shareSection.find('.page-share__facebook').on('click', () => {
      $('.at-svc-facebook span').click();
    });
    this.shareSection.find('.page-share__linkedin').on('click', () => {
      $('.at-svc-linkedin span').click();
    });
    this.shareSection.find('.page-share__twitter').on('click', () => {
      $('.at-svc-twitter span').click();
    });
    this.shareSection.find('.page-share__share').on('click', () => {
      $('.at4-share-count-anchor span').click();
    });
  }
}
